const customerSummaryConstants = {
  REDEEMED_COUPONS: 'redeemed_coupons',
  REDEEMED_COUPONS_HEADER: 'Redeemed Coupons',
  NO_COUPONS_MESSAGE: 'No coupons to show',
  TABLE_HEADERS: {
    COUPON_CODE: 'Coupon Code',
    AMOUNT_SAVED: 'Saved',
    REDEEMED_ON: 'Redeemed On',
    ORDER_ID: 'Order ID',
  },
  SHOW_MORE_CTA: 'Show more',
};

const CREDENTIAL_RESET_MESSAGES = {
  pinSuccessfullReset: "Your User PIN has been changed successfully!",
  passwordSuccessfullReset: "Your Password has been changed successfully!",
  changeRequiredHeader: "Change Required",
  errorMessage: "Unable to change credentials. Please try again later.",
  changeUserText: "Change User",
};

export { customerSummaryConstants, CREDENTIAL_RESET_MESSAGES };